module.exports = __webpack_public_path__ + "img/crosskey.d6313e30.svg";